<template>
  <div v-if="userInfo.userKind === 'Player' && !hasBindSuccess && !this.userInfo.boundLine" class="bind-line-tip-wrap">
    <div @click="jumpBindLineNotify">
      <div>
        <img src="~@/assets/image/icons/icon-line.png" alt="">
        <span>{{$t('upgrade_page_views_chat_components_bind_line_tip_1759')}}</span>
      </div>
      <img src="~@/assets/image/icons/arrow-right-gray-2.png" alt="">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['userInfo'])
  },
  data() {
    return {
      hasBindSuccess: false,
    }
  },
  mounted() {
    window.addEventListener('message', event => {
      if (event.origin === location.origin && event.data && event.data.type === 'BIND_LINE_NOTIFY_RESULT') {
        this.hasBindSuccess = event.data.data
      }
    })
  },
  methods: {
    jumpBindLineNotify() {
      this.$util.openWindow('/user/bind/line')
    }
  }
}
</script>

<style lang="scss" scoped>
  .bind-line-tip-wrap {
    @include flex();
    height: 40px;
    background: #202635;

    &>div {
      width: 100%;
      height: 100%;
      @include flex(space-between);
      cursor: pointer;
      div {
        @include flex();
      }
    }

    img:first-child {
      width: 20px;
      height: 20px;
      margin-left: 20px;
    }

    img:last-child {
      width: 16px;
      height: 16px;
      margin-right: 12px;
    }

    span {
      font-size: 14px;
      line-height: 20px;
      margin-left: 8px;
      color: $color-gray-3;
    }
  }
</style>